import * as React from 'react';
import { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { Icon } from 'antd';

const css = require('./index.scss');

enum MessageType {
    消息 = 0, 错误, 警告, 成功,
}

/** Props接口 */
interface MessageIProps {

    /** 组件容器 */
    container: Element;

    /** 消息类型 */
    type: MessageType;

    /** 自动关闭毫秒数 */
    duration: number;
}

class MessageState {

    /** 是否显示 */
    public isShow: boolean = false;
}

/** 消息展示组件 */
export default class Message extends React.PureComponent<MessageIProps, MessageState> {

    state = new MessageState();

    // 关闭计时器
    private durationTimer: NodeJS.Timer;

    public static info(content: ReactNode, duration: number = 2000) {
        const container = Message.initContainer();
        ReactDOM.render(<Message type={MessageType.消息} duration={duration} container={container} >{content}</Message>, container);
    }

    public static warning(content: ReactNode, duration: number = 2000) {
        const container = Message.initContainer();
        ReactDOM.render(<Message type={MessageType.警告} duration={duration} container={container} >{content}</Message>, container);
    }

    public static error(content: ReactNode, duration: number = 2000) {
        const container = Message.initContainer();
        ReactDOM.render(<Message type={MessageType.错误} duration={duration} container={container} >{content}</Message>, container);
    }

    public static success(content: ReactNode, duration: number = 2000) {
        const container = Message.initContainer();
        ReactDOM.render(<Message type={MessageType.成功} duration={duration} container={container} >{content}</Message>, container);
    }

    // 初始化一个 react 容器
    private static initContainer() {
        const div = document.createElement('div');
        window.document.body.appendChild(div);
        return div;
    }

    render() {
        return (
            <div className={this.className} >
                <Icon className={css.close} onClick={this.close} type="guanbi" />
                {this.renderMessage(this.props.children)}
            </div>
        );
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isShow: true });
        }, 200);

        if (this.props.duration) {
            this.durationTimer = setTimeout(this.close, this.props.duration);
        }
    }

    private get className(): string {
        if (this.state.isShow) {
            return `${css.message} ${css.show}`;
        } else {
            return `${css.message}`;
        }
    }

    /** 消息图标 */
    private messageIcon = () => {
        switch (this.props.type) {
            case MessageType.消息:
                return <img src={require('./IMG.info.svg')} alt="" />;

            case MessageType.警告:
                return <img src={require('./IMG.warning.svg')} alt="" />;

            case MessageType.错误:
                return <img src={require('./IMG.error.svg')} alt="" />;

            case MessageType.成功:
                return <img src={require('./IMG.success.svg')} alt="" />;

            default:
                return null;
        }
    }

    /** 显示内容 */
    private renderMessage = (content: ReactNode) => {
        return (
            <span>
                {this.messageIcon()}
                {content}
            </span>
        );
    }

    /** 关闭 */
    private close = () => {
        this.setState({ isShow: false });
        clearTimeout(this.durationTimer);
        setTimeout(() => {
            ReactDOM.unmountComponentAtNode(this.props.container);
            window.document.body.removeChild(this.props.container);
        }, 300);
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/component/Message/index.tsx